import { useHeaderBarToolsContainer } from "@/features/common/components/HeaderBarProvider";
import type { FC, PropsWithChildren } from "react";
import { createPortal } from "react-dom";

export const HeaderBarTools: FC<PropsWithChildren> = ({ children }) => {
	const container = useHeaderBarToolsContainer();

	if (!container) {
		return null;
	}

	return createPortal(children, container);
};
